export default {
  name: "Vedha Sundar",
  feedback: `Myself attended brownie and blondie workshop. The session was too good and the tips and tricks which mam provided us was very helpful. 
  Will attend future classes for sure. Ramya mam is very knowledgeable and kind hearted person in this field. 
  The taste of the brownies which we made is very delicious.`
};
